export class UrlPartInfo {
    public culture?: string;
    public urlForEntitiesWithSlug?: string;
    public urlForEntitiesWithoutSlug?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): UrlPartInfo {
        const urlPartInfo: UrlPartInfo = new UrlPartInfo();

        urlPartInfo.culture = this.culture;
        urlPartInfo.urlForEntitiesWithSlug = this.urlForEntitiesWithSlug;
        urlPartInfo.urlForEntitiesWithoutSlug = this.urlForEntitiesWithoutSlug;

        return urlPartInfo;
    }
}
